import { render, staticRenderFns } from "./BaseLangEntityBlock.vue?vue&type=template&id=32fa7f4a"
import script from "./BaseLangEntityBlock.vue?vue&type=script&lang=js"
export * from "./BaseLangEntityBlock.vue?vue&type=script&lang=js"
import style0 from "./BaseLangEntityBlock.vue?vue&type=style&index=0&id=32fa7f4a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports